import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  Card,
  CardHeader,
  CardBody,
  List,
  ListItem,
  ListIcon,
  Spinner,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import BtcSignalsTable from "./BtcSignalsTable";

const BitcoinTrendIndicators = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://blindfoldcapital.com/api/ta/recent_btc_signals");
        const result = await response.json();
        setData(result.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <Box  mx="auto" mt={5}  overflow='auto'>
      <Card borderRadius="2xl" boxShadow="lg">
        <CardHeader>
          <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold">
            Bitcoin Trend & Indicators API
          </Text>
        </CardHeader>
        <CardBody>
          <Text fontSize={{ base: "sm", md: "md" }} mb={4}>
            The <strong>Bitcoin Trend & Indicators API</strong> provides real-time trading insights by analyzing <strong>Relative Strength Index (RSI), Exponential Moving Averages (EMA) and
            Volume Weighted Average Price (VWAP)</strong>. The API dynamically generates insights 
            for different time intervals to improve trading strategies.
          </Text>
          
        



          {loading ? (
            <Spinner size="lg" />
          ) : (
            <>
            <BtcSignalsTable/>
              {/**<TableContainer overflowX="auto">
              <Table variant="simple" size={{ base: "sm", md: "md" }}>
                <Thead>
                  <Tr>
                    <Th>Timestamp</Th>
                    <Th>Interval</Th>
                    <Th>RSI</Th>
                    <Th>EMA Fast</Th>
                    <Th>EMA Slow</Th>
                    <Th>VWAP</Th>
                    <Th>Signal</Th>
                    <Th>Direction</Th>
                    <Th>Long Lev</Th>
                    <Th>Short Lev</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.map((item, index) => (
                    <Tr key={index}>
                      <Td>{item.timestamp}</Td>
                      <Td>{item.interval}</Td>
                      <Td>{item.rsi.toFixed(2)}</Td>
                      <Td>{item.ema_fast.toFixed(2)}</Td>
                      <Td>{item.ema_slow.toFixed(2)}</Td>
                      <Td>{item.vwap.toFixed(2)}</Td>
                      <Td>{item.signal}</Td>
                      <Td>{item.direction}</Td>
                      <Td>{item.long_leverage}x</Td>
                      <Td>{item.short_leverage}x</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer> */}
            </>
          )}
        </CardBody>
      </Card>
    </Box>
  );
};

export default BitcoinTrendIndicators;
